import { render, staticRenderFns } from "./IUserPicker.vue?vue&type=template&id=2d27ba48&"
import script from "./IUserPicker.vue?vue&type=script&lang=js&"
export * from "./IUserPicker.vue?vue&type=script&lang=js&"
import style0 from "./IUserPicker.vue?vue&type=style&index=0&id=2d27ba48&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports